import BaseError, { ErrorProps } from './BaseError';

export const Error404 = (props: ErrorProps) => (
  <BaseError
    description="The page you're looking for doesn't exist or has been moved."
    title="Page Not Found"
    {...props} />
);
